import Adjust from '@adjustcom/adjust-web-sdk';

import {
  ADJUST_APP_TOKEN,
  ADJUST_ENVIRONMENT,
  CUSTOMER_ID_PARAMETER,
} from './adjust-sdk.constants';

import type { AdjustSDK } from './adjust-sdk.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getAdjustInitializer: AdjustSDK['getAdjustInitializer'] = (track) => {
  Adjust.initSdk({
    appToken: ADJUST_APP_TOKEN,
    environment: ADJUST_ENVIRONMENT,
    logLevel: 'info',
    attributionCallback: (_event, attribution) => {
      track('adjust.attribution', { ...attribution });
    },
  });
};

export const enable: AdjustSDK['enable'] = () => {
  Adjust.restart();
};

export const disable: AdjustSDK['disable'] = () => {
  Adjust.stop();
};

export const clearCustomer: AdjustSDK['clearCustomer'] = () => {
  Adjust.removeGlobalCallbackParameter(CUSTOMER_ID_PARAMETER);
};

export const syncCustomer: AdjustSDK['syncCustomer'] = (userId) => {
  if (userId) {
    Adjust.addGlobalCallbackParameters([{ key: CUSTOMER_ID_PARAMETER, value: userId }]);
    return;
  }

  clearCustomer();
};
